export default __webpack_public_path__ + "static/media/relaxing-dog-headphones.eca1d68d.jpg";